import { Button, FlexLayout } from '@deity/falcon-ui';
import { Checkbox } from '@deity-io/portal-ui';
import { TextField } from '@mui/material';
import type { FC } from 'react';
import { useState } from 'react';

interface ILogsFilter {
  startDate?: Date;
  endDate?: 'now' | Date;
}

export interface ILogsFilterProps {
  onFilter: (filter: ILogsFilter) => void;
  defaultStartDate?: Date;
  defaultEndDate?: 'now' | Date;
}

export const LogsFilter: FC<ILogsFilterProps> = ({ onFilter, defaultStartDate, defaultEndDate = 'now' }) => {
  const [logFilter, setLogFilter] = useState<ILogsFilter>({ endDate: defaultEndDate, startDate: defaultStartDate });
  /**
   * Format the date to the timePickers input format
   */
  const formatDate = (date: Date): string => {
    const pad = (input: number): string => (input < 10 ? `0${input}` : `${input}`);
    const output = `${date.getFullYear()}-${pad(date.getMonth())}-${pad(date.getDay())}T${pad(date.getHours())}:${pad(
      date.getMinutes()
    )}:${pad(date.getSeconds())}`;

    return output;
  };

  if (defaultStartDate) {
    formatDate(defaultStartDate);
  }

  return logFilter.startDate ? (
    <FlexLayout p="xs" flexDirection="row">
      From
      <TextField
        id="datetime-local"
        type="datetime-local"
        value={formatDate(logFilter.startDate)}
        onChange={e => {
          setLogFilter({ ...logFilter, startDate: new Date(e.target.value) });
        }}
        InputLabelProps={{
          shrink: true
        }}
      />
      To
      <FlexLayout flexDirection="column">
        <FlexLayout flexDirection="row">
          <Checkbox
            checked={logFilter.endDate === 'now'}
            onChange={(e, value) => {
              setLogFilter({ ...logFilter, endDate: 'now' });
            }}
          />
          Now
        </FlexLayout>
        <FlexLayout flexDirection="row">
          <Checkbox
            checked={logFilter.endDate !== 'now'}
            onChange={(e, value) => {
              setLogFilter({ ...logFilter, endDate: new Date() });
            }}
          />
          <TextField
            disabled={logFilter.endDate === 'now'}
            id="datetime-local"
            type="datetime-local"
            sx={{ width: 250 }}
            value={formatDate(logFilter.endDate && logFilter.endDate !== 'now' ? logFilter.endDate : new Date())}
            InputLabelProps={{
              shrink: true
            }}
            onChange={e => {
              setLogFilter({ ...logFilter, endDate: new Date(e.target.value) });
            }}
          />
        </FlexLayout>
      </FlexLayout>
      <Button title="Filter" onClick={() => onFilter(logFilter)}>
        Filter
      </Button>
    </FlexLayout>
  ) : null;
};
